// export { default as AnalyticsProvider } from './console';
export { default as AnalyticsProvider, type EventProperties } from './mixpanel';
